import { useContext } from "react";

import { TopBarOverrideContext } from "../../context/sectionTabs/TopBarOverrideContext";
import type { TopBarOverrideContextValue } from "../../context/sectionTabs/types";

const noop = () => {};

/**
 * No-op fallback when consumed outside a MobileSectionTabsProvider.
 */
const FALLBACK_CONTEXT: TopBarOverrideContextValue = {
  topBarOverride: null,
  setTopBarOverride: noop,
};

/**
 * Register/read a full custom-element override that replaces the mobile
 * shell's entire TopBar.
 */
export const useMobileTopBarOverride = () => {
  const context = useContext(TopBarOverrideContext);
  if (!context && process.env.NODE_ENV === "development") {
    console.warn(
      "useMobileTopBarOverride: called outside MobileSectionTabsProvider, using noop fallback. " +
        "This is expected for pages on the legacy app shell path.",
    );
  }
  return context ?? FALLBACK_CONTEXT;
};
